import CacheTag from '@/redux/services/cacheTags';
import { serviceLevelDefinitionsApi as generatedServiceLevelDefinitionsApi } from '../endpoints/serviceLevelDefinitions';

export const serviceLevelDefinitionsApi =
  generatedServiceLevelDefinitionsApi.enhanceEndpoints({
    endpoints: {
      listServiceLevelDefinitions: {
        providesTags: [{ type: CacheTag.ServiceLevelDefinition }],
      },
      getServiceLevelDefinitionById: {
        providesTags: (_result, _error, queryArg) => [
          { type: CacheTag.ServiceLevelDefinition, id: queryArg.recId },
        ],
      },
      createServiceLevelDefinition: {
        invalidatesTags: [{ type: CacheTag.ServiceLevelDefinition }],
      },
      updateServiceLevelDefinition: {
        invalidatesTags: [{ type: CacheTag.ServiceLevelDefinition }],
      },
      deleteServiceLevelDefinition: {
        invalidatesTags: [{ type: CacheTag.ServiceLevelDefinition }],
      },
      updateServiceLevelDefinitionNsbSetups: {
        invalidatesTags: [{ type: CacheTag.ServiceLevelDefinition }],
      },
    },
  });

export {
  AgreementLicenseType,
  CalculationMethod,
  DocumentLanguage,
  DocumentService,
  NoYesEnum,
  PreviousVersion,
} from '../endpoints/serviceLevelDefinitions';

export type {
  ClassifierDtos,
  CreateServiceLevelDefinitionApiArg,
  CreateServiceLevelDefinitionApiResponse,
  CreateServiceLevelDefinitionRequest,
  DeleteServiceLevelDefinitionApiArg,
  DeleteServiceLevelDefinitionApiResponse,
  DeleteServiceLevelDefinitionNsbSetupApiArg,
  DeleteServiceLevelDefinitionNsbSetupApiResponse,
  GetServiceLevelDefinitionByIdApiArg,
  GetServiceLevelDefinitionByIdApiResponse,
  ListServiceLevelDefinitionClassifiersApiArg,
  ListServiceLevelDefinitionClassifiersApiResponse,
  ListServiceLevelDefinitionNsbSetupsApiArg,
  ListServiceLevelDefinitionNsbSetupsApiResponse,
  ListServiceLevelDefinitionNsbsApiArg,
  ListServiceLevelDefinitionNsbsApiResponse,
  ListServiceLevelDefinitionsApiArg,
  ListServiceLevelDefinitionsApiResponse,
  ServiceLevelDefinitionDto,
  ServiceLevelDefinitionNsbDto,
  ServiceLevelDefinitionNsbSetupDto,
  ServiceLevelDefinitionNsbSetupModel,
  SpError,
  SpProblemDetails,
  UpdateServiceLevelDefinitionApiArg,
  UpdateServiceLevelDefinitionApiResponse,
  UpdateServiceLevelDefinitionNsbSetupsApiArg,
  UpdateServiceLevelDefinitionNsbSetupsApiResponse,
  UpdateServiceLevelDefinitionRequestBody,
} from '../endpoints/serviceLevelDefinitions';

export const {
  useUpdateServiceLevelDefinitionMutation,
  useGetServiceLevelDefinitionByIdQuery,
  useLazyGetServiceLevelDefinitionByIdQuery,
  useDeleteServiceLevelDefinitionMutation,
  useUpdateServiceLevelDefinitionNsbSetupsMutation,
  useListServiceLevelDefinitionNsbSetupsQuery,
  useLazyListServiceLevelDefinitionNsbSetupsQuery,
  useListServiceLevelDefinitionNsbsQuery,
  useLazyListServiceLevelDefinitionNsbsQuery,
  useDeleteServiceLevelDefinitionNsbSetupMutation,
  useListServiceLevelDefinitionsQuery,
  useLazyListServiceLevelDefinitionsQuery,
  useCreateServiceLevelDefinitionMutation,
  useListServiceLevelDefinitionClassifiersQuery,
  useLazyListServiceLevelDefinitionClassifiersQuery,
} = serviceLevelDefinitionsApi;
